export default __webpack_public_path__ + "static/media/PorscheCar.ee2bf732.svg";